import React from 'react';
import { CreditCardType } from '../../organisms/CreditCard/types';
import { AmericanExpress, Bogus, Discover, Master, Visa } from './components';

export const LOGOS: Record<CreditCardType, React.FC> = {
  american_express: AmericanExpress,
  bogus: Bogus,
  discover: Discover,
  master: Master,
  visa: Visa,
  diners_club: undefined,
  jcb: undefined,
  switch: undefined,
  solo: undefined,
  dankort: undefined,
  maestro: undefined,
  forbrugsforeningen: undefined,
  laser: undefined,
};
